import { Suspense, useEffect } from 'react';
import { Outlet } from 'react-router-dom';

// hooks
import { useRedux } from '../hooks/';

// utils
import { changeBodyAttribute } from '../utils/layout';

const loading = () => <div className=""></div>;

type DefaultLayoutProps = {};

const DefaultLayout = (props: DefaultLayoutProps) => {
    const { useAppSelector } = useRedux();

    // const { layoutColor } = useAppSelector((state) => ({
    //     layoutColor: state.Layout.layoutColor,
    // }));

    // useEffect(() => {
    //     changeBodyAttribute('data-layout-color', layoutColor);
    // }, [layoutColor]);

    return (
        <Suspense fallback={loading()}>
            <Outlet />
        </Suspense>
    );
};
export default DefaultLayout;
